export default __webpack_public_path__ + "static/media/oliver-pecker-HONJP8DyiSM-unsplash.3343adfd.png";